const serverUrl = process.env.VUE_APP_ROOT_API_SERVER_URL;
const securityCode = process.env.VUE_APP_ROOT_API_SECURITY_CODE;

export default {
  async deleteCage(id) {
    try {
      const url = `${serverUrl}/api/cage/${id}?code=${securityCode}`;
      const options = { method: 'DELETE' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to Delete Cage (${e.message})`)
    }
  },

  async deleteDissect(id) {
    try {
      const url = `${serverUrl}/api/dissect/${id}?code=${securityCode}`;
      const options = { method: 'DELETE' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to Delete Dissect (${e.message})`)
    }
  },

  async deleteFixedParam(id) {
    try {
      const url = `${serverUrl}/api/fixedparam/${id}?code=${securityCode}`;
      const options = { method: 'DELETE' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to Delete Fixed Param (${e.message})`)
    }
  },

  async deleteIndex(id) {
    try {
      const url = `${serverUrl}/api/index/${id}?code=${securityCode}`;
      const options = { method: 'DELETE' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to Delete Index (${e.message})`)
    }
  },

  async deleteProportion(id) {
    try {
      const url = `${serverUrl}/api/proportion/${id}?code=${securityCode}`;
      const options = { method: 'DELETE' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to Delete Proportion (${e.message})`)
    }
  },

  async getCages() {
    try {
      const url = `${serverUrl}/api/cage?code=${securityCode}`;
      const options = { method: 'GET' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Cage Values from server (${e.message})`)
    }
  },

  async getDissects() {
    try {
      const url = `${serverUrl}/api/dissect?code=${securityCode}`;
      const options = { method: 'GET' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Dissect Values from server (${e.message})`)
    }
  },

  async getFixedParams() {
    try {
      const url = `${serverUrl}/api/fixedparam?code=${securityCode}`;
      const options = { method: 'GET' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Fixed Param Values from server (${e.message})`)
    }
  },

  async getIndexes() {
    try {
      const url = `${serverUrl}/api/index?code=${securityCode}`;
      const options = { method: 'GET' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Index Values from server (${e.message})`)
    }
  },

  async getProportions() {
    try {
      const url = `${serverUrl}/api/proportion?code=${securityCode}`;
      const options = { method: 'GET' };
      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to retrieve Proportion Values from server (${e.message})`)
    }
  },

  async postCage(cageObj) {
    try {
      const url = `${serverUrl}/api/cage?code=${securityCode}`;
      const payload = JSON.stringify(cageObj);
      const options = { 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: payload
      };

      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to post Cage Values to server (${e.message})`)
    }
  },

  async postDissect(obj) {
    try {
      const url = `${serverUrl}/api/dissect?code=${securityCode}`;
      const payload = JSON.stringify(obj);
      const options = { 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: payload
      };

      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to post Dissect Values to server (${e.message})`)
    }
  },

  async postFixedParam(obj) {
    try {
      const url = `${serverUrl}/api/fixedparam?code=${securityCode}`;
      const payload = JSON.stringify(obj);
      const options = { 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: payload
      };

      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to post Fixed Param Values to server (${e.message})`)
    }
  },

  async postIndex(obj) {
    try {
      const url = `${serverUrl}/api/index?code=${securityCode}`;
      const payload = JSON.stringify(obj);
      const options = { 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: payload
      };

      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to post Index Values to server (${e.message})`)
    }
  },

  async postProportion(obj) {
    try {
      const url = `${serverUrl}/api/proportion?code=${securityCode}`;
      const payload = JSON.stringify(obj);
      const options = { 
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: payload
      };

      let results = await fetch(url,options);
      if (!results.ok) await this.throwError(results);
      return results;
    }
    catch(e) {
      throw new Error(`Unable to post Proportion Values to server (${e.message})`)
    }
  },

  async throwError(response) {
    switch (response.status) {
      case 400: {
        const error = await response.json();
        if (error) {
          throw new Error(`${error.title} [${response.status}]: ${error.message}`);
        }
        throw new Error(`${response.status}: Server Error`);
      }
      case 401: 
        throw new Error(`${response.status}: Unathorized`);
      case 500: {
        const msg = await response.text();
        if (msg) {
          throw new Error(`${response.status}: Internal Server Error - ${msg}`);
        }
        throw new Error(`${response.status}: Internal Server Error`);
      }
      default:
        throw new Error(`${response.status}: Server Error`);
    }
  }
}